import DailyStatsChartComonent from 'components/DailyStatsChartCard/DailyStatsChart';
import useDailyStatsChart from 'components/DailyStatsChartCard/useDailyStatsChart';
import { PeriodArgs } from 'components/StatsPeriodSelector';
import React from 'react';
import { useDailyPodcastMetrics } from '../state';
import { CHART_STATS_SELECTOR_OPTIONS } from './utils';

type DailyStatsChartProps = {
  periodArgs: PeriodArgs;
  episodeId?: string;
};

const DailyStatsChart: React.FC<DailyStatsChartProps> = ({
  periodArgs,
  episodeId,
}) => {
  const { data: dailyStatsData = [] } = useDailyPodcastMetrics({
    startMillis: periodArgs.startMillis,
    endMillis: periodArgs.endMillis,
    remoteEpisodeId: episodeId,
  });

  const { data } = useDailyStatsChart({
    initialSelectedSeries: 'plays',
    seriesData: dailyStatsData,
  });

  return (
    <DailyStatsChartComonent
      selectedAxisData={data}
      selectedStat="plays"
      statOptions={CHART_STATS_SELECTOR_OPTIONS}
      showTotal
      showLegend={false}
    />
  );
};
export default DailyStatsChart;
